module.exports = __webpack_public_path__ + "img/icon-admin-lock-off.6a66c90c.svg";